export const formatWalletAddress = (address) => {
  //console.log("formatWalletAddress: ", address);
  if ((address) && (address !== "")) {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }
  return "";
}
